export const PODCAST_APPSYNC_WRITE_METHOD = 'Podcast.Web.AppSyncInterface.WriteMethod';
